export default __webpack_public_path__ + "static/media/gallery-wip-emitter_02.f0163ea7.jpg";